import { uuid } from "./common";

export function obsoletableFn(fn: Function) {
  let lastCaller: symbol = null as any;

  return (...args: any[]) => {
    const me = Symbol();
    lastCaller = me;

    const isObsolete = () => lastCaller !== me;

    return fn(isObsolete, ...args);
  };
}

export const cancellablePromise = (promise: Promise<any | void>) => {
  const isCancelled = { value: false };
  const wrappedPromise = new Promise((res, rej) => {
    promise
      .then((d) => {
        return isCancelled.value ? rej(isCancelled) : res(d);
      })
      .catch((e) => {
        rej(isCancelled.value ? isCancelled : e);
      });
  });

  return {
    promiseId: uuid(),
    promise: wrappedPromise,
    cancel: () => {
      isCancelled.value = true;
    },
  };
};
